module.exports = __webpack_public_path__ + "img/a12.e4f35a19.png";